/* eslint-disable react/prop-types */ // TODO: add props
import cx from 'classnames';
import style from './InlineAlert.scss';
import { Success, Error, Warning, Info } from './Icon';
import PT from 'prop-types';

const InlineAlert = ({
  children,
  type,
  iconClassName,
  className,
  ...props
}) => {
  const Icon = {
    success: Success,
    error: Error,
    warning: Warning,
    info: Info,
  }[type];

  return (
    <span className={cx(style.inlineAlert, className, style[type])} {...props}>
      {Icon ? <Icon className={cx(style.icon, iconClassName)} /> : null}
      <span className={style.message}>{children}</span>
    </span>
  );
};

InlineAlert.defaultProps = {
  type: 'success',
};

InlineAlert.propTypes = {
  type: PT.oneOf(['success', 'error', 'warning', 'info']),
};

InlineAlert.Success = (props) => <InlineAlert {...props} type="success" />;
InlineAlert.Error = (props) => <InlineAlert {...props} type="error" />;
InlineAlert.Warning = (props) => <InlineAlert {...props} type="warning" />;
InlineAlert.Info = (props) => <InlineAlert {...props} type="info" />;

export default InlineAlert;
